// The samples the developer pages show, read verbatim from the files beside this one. Each file is
// a program that runs as it stands against https://v2.paige.app, and each was run there end to end
// before it was published (docs/engineering/api.md, "Samples"): change one, run it again.
import quickstartCurl from './quickstart.sh?raw';
import quickstartPython from './quickstart.py?raw';
import quickstartCsharp from './Quickstart.cs?raw';
import quickstartJavascript from './quickstart.mjs?raw';
import verifyPython from './verify.py?raw';
import verifyCsharp from './Verify.cs?raw';
import verifyJavascript from './verify.mjs?raw';
import type { Snippets } from '../CodeSample';

/** The whole quickstart: a job, a batch, the wait, the documents and their PDFs. */
export const quickstart: Snippets = {
  curl: quickstartCurl,
  python: quickstartPython,
  csharp: quickstartCsharp,
  javascript: quickstartJavascript,
};

/** Checking a webhook delivery's signature. */
export const verifySignature: Snippets = {
  python: verifyPython,
  csharp: verifyCsharp,
  javascript: verifyJavascript,
};
